// extracted by mini-css-extract-plugin
export default {"tableHeading":"chainSettingsTable__tableHeading___-Fv0X"};